/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setIntro.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const html = document.querySelector("html");
const tutorial = document.getElementById("tutorial");
const intro = document.getElementById("intro");
const startArea = document.querySelector(".intro__start-area");
const ilustArea = document.querySelector(".intro__ilust-area");
const ilustGroup01 = document.querySelector(".--group01");
const ilustGroup02 = document.querySelector(".--group02");
const ilustGroup03 = document.querySelector(".--group03");
const ilustGroup04 = document.querySelector(".--group04");
const ilustGroup05 = document.querySelector(".--group05");
const ilustGroup06 = document.querySelector(".--group06");
const ilustGroup07 = document.querySelector(".--group07");
let ilustGroup01__item01 = document.querySelector(".--group01 .--ilust02");
let ilustGroup01__item02 = document.querySelector(".--group01 .--ilust10");
let ilustGroup01__items = [ilustGroup01__item01, ilustGroup01__item02];

let ilustGroup02__item01 = document.querySelector(".--group02 .--text01");
let ilustGroup02__item02 = document.querySelector(".--group02 .--text02");
let ilustGroup02__items = [ilustGroup02__item01, ilustGroup02__item02];

let ilustGroup03__item01 = document.querySelector(".--group03 .--text03");
let ilustGroup03__item02 = document.querySelector(".--group03 .--ilust11");
let ilustGroup03__items = [ilustGroup03__item01, ilustGroup03__item02];

let ilustGroup05__item01 = document.querySelector(".--group05 .--ilust04");
let ilustGroup05__item02 = document.querySelector(".--group05 .--ilust05");
let ilustGroup05__item03 = document.querySelector(".--group05 .--ilust08");
let ilustGroup05__items = [ilustGroup05__item01, ilustGroup05__item02, ilustGroup05__item03];

/**
 * 処理
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function setIntro() {
    let animationProps = { duration: 3.5, ease: "power2.inOut", }
    let blurIn = { filter: "blur(20px)", duration: 2, ease: "power1.inOut" }
    let blurOut = { filter: "blur(0px)", duration: 1, ease: "power1.inOut" }
    let scaleOut = { scale: 2, ...animationProps }
    let moveLeftUp = { xPercent: -50, yPercent: -50, ...animationProps }
    let moveRightUp = { xPercent: 50, yPercent: -50, ...animationProps }
    let moveRightDown = { xPercent: 50, yPercent: 50, ...animationProps }
    intro.addEventListener('click', () => {
        let $myWindow = "visited";
        let tl = gsap.timeline()
        html.classList.add("--states-start");

        tl.to(startArea, { opacity: 0.001, duration: 2, ease: "ease", })
            .to(ilustArea, { scale: 3, duration: 13, ease: "power1.inOut", }, "<0.5")
            //tia01
            .to(ilustGroup01, { ...scaleOut }, "<")
            .to(ilustGroup01__items[0], { xPercent: 10, yPercent: 10, ...animationProps }, "<")
            .to(ilustGroup01__items[1], { xPercent: -10, yPercent: -10, ...animationProps }, "<")
            .to(ilustGroup01, { ...blurIn }, "<0.55")
            //tia02
            .to(ilustGroup02, { ...blurOut }, "<")
            .to(ilustGroup02, { ...scaleOut }, "<0.95")
            .to(ilustGroup02__items[0], { ...moveRightDown }, "<")
            .to(ilustGroup02__items[1], { ...moveLeftUp }, "<")
            .to(ilustGroup02, { ...blurIn }, "<0.55")
            //tia03
            .to(ilustGroup03, { ...blurOut }, "<")
            .to(ilustGroup03, { ...scaleOut }, "<0.95")
            .to(ilustGroup03__items[0], { ...moveRightUp }, "<")
            .to(ilustGroup03__items[1], { xPercent: -100, yPercent: 100, ...animationProps }, "<")
            .to(ilustGroup03, { ...blurIn }, "<0.55")
            //tia04
            .to(ilustGroup04, { ...blurOut }, "<")
            .to(ilustGroup04, { ...scaleOut }, "<0.95")
            .to(ilustGroup04, { ...blurIn }, "<0.55")
            //tia05
            .to(ilustGroup05, { ...blurOut }, "<")
            .to(ilustGroup05, { ...scaleOut }, "<0.95")
            .to([ilustGroup05__items[0], ilustGroup05__items[2]], { yPercent: 25, ...animationProps }, "<")
            .to(ilustGroup05__items[1], { xPercent: -20, rotateZ: -40, ...animationProps }, "<")
            .to(ilustGroup05, { ...blurIn }, "<0.55")
            //tia06
            .to(ilustGroup06, { ...blurOut }, "<")
            .to(ilustGroup06, { ...scaleOut }, "<1")
            .to(ilustGroup06, { ...blurIn }, "<0.75")
            //tia07
            .to(ilustGroup07, { ...blurOut }, "<")
            .to(intro, {
                opacity: 0.001, duration: 1, ease: "ease.out",
                onComplete: () => {
                    html.classList.remove("--states-start");
                    html.classList.add("--states-complete");
                    intro.remove();
                    if (window.name.indexOf($myWindow) == -1) {
                        window.name = $myWindow;
                        html.classList.add("--open-modal");
                        tutorial.classList.add("--active");
                    }
                }
            }, "<3")
    });
}

/**
 * 書き出し
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setIntro };